(function() {
    'use strict';
    
    angular.module('quantixApp').config(stateConfig, treeConfig);

	treeConfig.$inject = [ 'ivhTreeviewOptionsProvider' ];

	function treeConfig(ivhTreeviewOptionsProvider) {
		ivhTreeviewOptionsProvider.set({

			
			validate : true
		});
	}
	stateConfig.$inject = [ '$stateProvider' ,'IdleProvider','KeepaliveProvider'];

    function stateConfig($stateProvider,IdleProvider,KeepaliveProvider) {
		// ideal Timeout added by c-veerrajuD
	 	IdleProvider.idle(27*60);
        //Timeout warning in seconds
    	IdleProvider.timeout(180);
    	KeepaliveProvider.interval(30);
    	
		$stateProvider.state('app', {
			abstract : true,
			views : {
				'navbar@' : {
					templateUrl : 'app/layouts/navbar/navbar_new.html',
					controller : 'NavbarController',
					controllerAs : 'vm'
				},
				'footer@' : {
					templateUrl : 'app/layouts/footer/footer.html',
					controller : 'FooterController',
					controllerAs : 'vm'
				},
				// 'sideBar@' : {
				// 	templateUrl : 'app/layouts/navbar/sidebar.html',
				// 	controller : 'SidebarController',
				// 	controllerAs : 'vm'
				// }
			},
			resolve : {
				authorize : [ 'Auth', function(Auth) {
					return Auth.authorize();
				} ],
				translatePartialLoader : [ '$translate',
						'$translatePartialLoader',
						function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('global');
						} ]
			}
		});
	}
})();
